import { inject, Injectable } from '@angular/core';
import { authActions } from '@libs/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import { EaglesoftPasswordPromptService } from './eaglesoft-password-prompt.service';

/** Owns the dialog between `eaglesoftCredentialPromptRequested` and the resolution the guard waits on. */
@Injectable({ providedIn: 'root' })
export class EaglesoftCredentialPromptEffects {
  private readonly actions$ = inject(Actions);
  private readonly promptService = inject(EaglesoftPasswordPromptService);

  public promptOnRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(authActions.eaglesoftCredentialPromptRequested),
      mergeMap(({ siteId }) =>
        this.promptService
          .prompt(siteId)
          .pipe(map((result) => authActions.eaglesoftCredentialPromptResolved({ siteId, success: !!result?.success }))),
      ),
    );
  });
}
